
$(document).ready(function() {

    var $betrieb = $("#acf-field_5de6532b66486");
    if (!$betrieb.length) {
        $betrieb = $("#acf-field_5e578325485ab");
    }
    var $pt = $("#acf-field_5dc0063c7cf61");
    if (!$pt.length) {
        $pt = $("#acf-field_5e57832548d78");
    }

    if ($betrieb.length && $pt.length) {
        var $betriebOptions = $betrieb.find('option');
        var $ptOptions = $pt.find('option');

        $betriebOptions.each(function() {
            var $this = $(this);
            var content = $this.text();
            var contentArray;

            $this.addClass("value_"+$this.attr('value'));

            if (content.indexOf('BJ::') !== -1) {
                contentArray = content.split("::");
                $this.text(contentArray[1]);
                $this.addClass('bj');
            }
        });
        $ptOptions.each(function() {
            var $this = $(this);
            var content = $this.text();
            var contentArray;

            if (content.indexOf('NBJ::') !== -1) {
                contentArray = content.split("::");
                console.log(contentArray);
                $this.text(contentArray[1]);
                $this.addClass('nbj');
            }
        });

    }

    $betrieb.change(change);

    $betrieb.change();

    function change() {
        var val = $( this ).val();
        var option = $(this).find('.value_'+val);
        if (option.hasClass('bj')) {
            $pt.find(".nbj").hide();
        } else {
            $pt.find(".nbj").show();
        }
    }

});
